export const sortingOptions = [
  { label: 'Sorting.option.dateTime', key: 'dateTime' },
  { label: 'Sorting.option.serialNumber', key: 'serialNumber' },
  { label: 'Sorting.option.installer', key: 'installer' },
  { label: 'Sorting.option.company', key: 'company' }
]
